export default {
    data: () => ({
        translations: {
            title: {
                el: "Πληρωμές μέσω Κινητού",
                en: "Mobile Payments",
                it: "Pagamenti Mobili"
            },
            appointCleaners: {
                el: "Ορίστε Εκκαθαριστές",
                en: "Appoint Clearers",
                it: "Nominare gli Addetti alle Pulizie"
            },
            paymentDirection: {
                el: "Δες τους Παρόχους Επεξεργασίας Πληρωμών",
                en: "View Payment Processors",
                it: "Visualizza Processori di Pagamento"
            }
        }
    })
};
